<template>
  <div class="w-full">
    <a-alert message="说明：加水机设备仅在本页配置的运行时间内可用；如果无任何配置，此设备24小时都可用。" show-icon style="margin-bottom:12px;" type="info" />
    <div class="table-operator" v-if="!disabled">
      <a-button @click="handleTableAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleTableSave" icon="save" type="primary">保存</a-button>

      <a-dropdown v-show="dataSource.length">
        <a-menu @click="handleMenuClick" slot="overlay">
          <a-menu-item key="1">
            <a-icon type="stop" />所有未配置的设备
          </a-menu-item>
          <a-menu-item key="2">
            <a-icon type="appstore" />所有设备
          </a-menu-item>
          <a-menu-item key="3">
            <a-icon type="check-square" />指定设备
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          应用到其他设备
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <j-vxe-table
      :columns="tableColumns"
      :dataSource="dataSource"
      :disabled="disabled"
      :height="300"
      :loading="loading"
      @edit-closed="handleEditClosed"
      keep-source
      ref="vTable"
      row-selection
    >
      <template v-if="!disabled" v-slot:action="props">
        <a-popconfirm @confirm="handleDL(props)" title="确定删除吗？">
          <a-button icon="delete" key="delete" size="small" type="danger"></a-button>
        </a-popconfirm>
      </template>
    </j-vxe-table>

    <j-select-device-by-process-modal :modal-width="1500" :multi="true" @ok="selectOK" ref="selectDevModal" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { getAction, postAction, putAction, deleteAction } from '@/api/manage';

  import JSelectDeviceByProcessModal from '@/components/jeecgbiz/modal/JSelectDeviceByProcessModal'

  export default {
    // 备件挂载型号专用
    name: 'DevAvailHoursList',
    components: {
      JSelectDeviceByProcessModal
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {
        tableColumns: [
          {
            title: '开始时间',
            key: 'startTime',
            defaultValue: '',
            sortable: true,
            type: JVXETypes.time,
            format: 'HH:mm',
            fixed: 'right',
            align: 'center',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],
          },
          {
            title: '结束时间',
            key: 'endTime',
            defaultValue: '',
            sortable: true,
            type: JVXETypes.time,
            fixed: 'right',
            align: 'center',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],
          },
          {
            title: '操作',
            key: 'action',
            type: JVXETypes.slot,
            fixed: 'right',
            width: '130px',
            align: 'center',
            slotName: 'action',
          }
        ],
        dataSource: [],
        loading: true,
        devModelList: [],
        url: {
          list: "/device/availHours/list",
          batchAdd: "/device/availHours/batchAdd",
          edit: "/device/availHours/edit",
          delete: "/device/availHours/delete",
          deleteBatch: "/device/availHours/deleteBatch",
          applyToOthers: "/device/availHours/applyToOthers",

        },
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      xTable () {
        return this.$refs?.vTable.$refs?.vxe.$refs.xTable ?? null
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    async created () {
      this.loadData()
    },
    // 方法集合
    methods: {
      //TODO 业务逻辑校验：时间不可交叉
      validateBizLogic (col, value) {
        return true
      },
      handleEditClosed (rows, v) {
        const { $table, col, value, type, column, row, rowId = '' } = rows

        if (!this.validateBizLogic(col, value)) {
          return
        }
        // 判断单元格值是否被修改
        let field = column.property
        if (!$table.isUpdateByRow(row, field)) {
          return
        }

        if (row.id.indexOf('row') < 0) {
          this.xTable?.validate(row).then((errMap) => {
            // 校验通过
            if (!errMap) {
              this.loading = true
              const fields = this.tableColumns.map(item => item.key)
              const params = this.$Jlodash.pick(row, fields)
              putAction(this.url.edit, { ...params, id: row.id }).then(res => {
                if (res.success) {
                  this.$message.success('编辑成功')
                }
              }).finally(() => {
                this.loading = false
              })
            }
          })
        }
      },
      handleTableSave () {
        const $table = this.$refs.vTable
        let newData = $table.getNewDataWithId()
        if (!newData.length) {
          this.$message.error('无新增数据！')
          return
        }
        const resultRows = newData.map(item => this.$Jlodash.omit(item, ['id']))

        $table.validate(newData).then((errMap) => {
          if (!errMap) {
            this.loading = true
            postAction(this.url.batchAdd, resultRows).then(res => {
              if (res.success) {
                this.$message.success(`保存成功！`)
              } else {
                this.$message.warn(`保存失败：` + res.message)
              }
            }).finally(() => {
              this.loading = false
              this.loadData()
            })
          }
        })
      },
      handleTableAdd () {
        this.$refs.vTable.pushRows([{
          devId: this.deviceData.id
        }], {
          index: 0,
          setActive: true,
        })
      },
      loadData () {
        const params = {
          devId: this.deviceData.id
        }
        getAction(this.url.list, params).then(res => {
          if (res.success) {
            this.dataSource = res.result.records
            this.selectedRows = []
          }
        }).finally(() => {
          this.loading = false
        })
      },
      handleDL (v) {
        const { row, rowId } = v
        if (rowId.indexOf('row_') > -1) {
          this.$refs.vTable.removeRows(row)
          return
        }

        deleteAction(this.url.delete, { id: row.id }).then(res => {
          if (res.success) {
            this.$refs.vTable.removeRows(row)
            this.$message.success('删除成功')
          }
        })

      },
      handleMenuClick (e, a) {
        const $table = this.$refs.vTable
        let newData = $table.getNewDataWithId();
        if (newData.length) {
          this.$message.error('请先保存修改的数据！')
          return
        }
        if ('2' == e.key) {
          this.$confirm({
            title: '应用到所有设备',
            content: (<div>
              <p>您确定要将运行时间配置应用到所有设备吗？</p>
              <p style="color:red;">注意：设备已有的配置会被覆盖！</p>
            </div>),
            centered: true,
            onOk: () => {
              this.applyToOthers('2')
            },
          });
        } else if ('3' == e.key) {
          this.$refs.selectDevModal.showModal()
        } else {
          this.applyToOthers('1')
        }
      },
      selectOK (rows) {
        if (rows.length > 0) {
          const devIds = rows.map(row => row.id);
          this.applyToOthers('3', devIds.join(','));
        }
      },
      applyToOthers (type, devIds) {
        console.log(type, devIds);
        this.loading = true
        postAction(this.url.applyToOthers, { type, devIds, config: this.dataSource }).then(res => {
          if (res.success) {
            this.$message.success('应用成功')
          }
        }).finally(() => {
          this.loading = false
          this.loadData()
        })
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>